import { useMutation } from "@tanstack/react-query";
import creativeStudioApiClient from "../creativeStudio";

/** Uploads one reference image and resolves to its public URL. */
const useUploadCreativeInputMutation = () =>
  useMutation({
    mutationKey: ["upload-creative-input"],
    mutationFn: (file: File) => creativeStudioApiClient.uploadInputImage(file),
  });

export default useUploadCreativeInputMutation;
